import React, { useEffect, useState, useMemo } from 'react';
import { getdata, formatdate, updatedata } from "../../util/global";
import PatientAdminTable from './PatientAdminTable';
import PatientView from './PatientView';
import PatientFileForm from './PatientFileForm';
import PatientAdminForm from './PatientAdminForm';

const PatientAdmin = () => {
  const [patientdata, setpatientdata] = useState([]);
  const [appointmentdata, setappointmentdata] = useState([]);
  const [prescriptiondata, setprescriptiondata] = useState([]);
  const [intakeformdata, setintakeformdata] = useState([]);

  const [filedata, setfiledata] = useState([]);

  const [searchquery, setsearchquery] = useState("");
  const [mode, setmode] = useState("");
  const [formdata, setformdata] = useState({ name: "", phonenumber: "", _id: null });

  const fetchdata = async () => {
    try {
      // Parallel fetch for clinical context
      const patdata = await getdata({ filter: { datatype: "patientdata" } });
      setpatientdata(patdata.reverse().filter(item => item.status !== "deleted"));
      
      const apptdata = await getdata({ filter: { datatype: "appointmentdata" } });
      setappointmentdata(apptdata.reverse());

      const presdata = await getdata({ filter: { datatype: "prescriptiondata" } });
      setprescriptiondata(presdata.reverse());

      const filedata = await getdata({ filter: { dbcollection:"appfiledata", datatype: "filedata" } });
      setfiledata(filedata.reverse());

      const formdata = await getdata({ filter: { datatype: "intakeformdata" } });
      setintakeformdata(formdata.reverse());

    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchdata(); }, []);

  const filteredpatients = useMemo(() => {
    return patientdata.filter(p => 
      p.name?.toLowerCase().includes(searchquery.toLowerCase()) || 
      p.phonenumber?.includes(searchquery)
    );
  }, [patientdata, searchquery]);

  const openview = (item) => {
    setformdata({ ...item });
    setmode("viewpatient");
  };

  const openedit = (item) => {
    setformdata({ ...item });
    setmode("editpatient");
  };


  const openfileform = () => {
    setformdata({ });
    setmode("showfileform");
  };

  const handlesubmit = async () => {
    const payload = {
      data: {
        ...formdata,
        datatype: "patientdata",
        appname: window.APPSETTING?.appname
      }
    };

    await updatedata(payload);
    await fetchdata();
    setmode("");
  };

  const handledropdownchange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (!value) return;

    if (value === "upload") {
      openfileform();
    } else if (value === "normal" || value === "sports") {
      const baseurl = "https://ssl.itpatil.com/intakeform";
      const queryparams = "appname=appointment&adminuserid=" + window.APPSETTING.adminuserid + 
      "&userid=" + window.APPUSER.user.userid;
      const targeturl = `${baseurl}?${queryparams}&formtype=${value}form`;
      window.open(targeturl, "_blank");
    }

    // Reset dropdown selection back to placeholder label
    e.target.value = "";
  };


  return (
    <div className="content-area">
      <div className="table-header-row">
        <h1 className="dash-title">
          Patient Management |
          <select 
            onChange={handledropdownchange} 
            defaultValue=""
            style={{ 
              fontSize: "13px", 
              padding: "4px 8px", 
              borderRadius: "4px", 
              border: "1px solid #ccc", 
              background: "#fff",
              cursor: "pointer",
              fontWeight: "normal",
              color: "#007bff",
              textDecoration: "underline"
            }}
          >
            <option value="" disabled hidden>Actions / Forms...</option>
            <option value="upload">Upload Document</option>
            <option value="normal">Normal Intake Form</option>
            <option value="sports">Sports Intake Form</option>
          </select>
        </h1>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input 
            type="text" 
            placeholder="Search name or phone..." 
            className="form-input" 
            style={{ width: '250px' }}
            value={searchquery}
            onChange={(e) => setsearchquery(e.target.value)}
          />
          <button className="btn-blue" onClick={() => {
            setformdata({ name: "", phonenumber: "", _id: null });
            setmode("editpatient");
          }}>+ New Patient</button>
        </div>
      </div>

      <PatientAdminTable 
        data={filteredpatients} 
        openview={openview} 
        openedit={openedit} 
      />
      
      <PatientView 
        mode={mode} 
        setmode={setmode} 
        formdata={formdata} 
        filedata={filedata.filter(a => a._patientid === formdata._id)}
        appointmentdata={appointmentdata.filter(a => a._patientid === formdata._id || a.phonenumber === formdata.phonenumber)}
        prescriptiondata={prescriptiondata.filter(p => p._patientid === formdata._id || p.phonenumber === formdata.phonenumber)}
        fetchdata={fetchdata}
        intakeformdata={intakeformdata.filter(p => p._patientid == formdata._id || p.phonenumber === formdata.phonenumber )}
      />

      <PatientFileForm 
        mode={mode} 
        setmode={setmode} 
        fetchdata={fetchdata}
        patientdata={patientdata}
      />

      <PatientAdminForm
        mode={mode}
        setmode={setmode}
        formdata={formdata}
        setformdata={setformdata}
        handlesubmit={handlesubmit}
      />

    </div>
  );
};

export default PatientAdmin;